/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllMatrixCareHomeHealthCopySourcesResponse } from './FindAllMatrixCareHomeHealthCopySourcesResponse';
import {
    FindAllMatrixCareHomeHealthCopySourcesResponseFromJSON,
    FindAllMatrixCareHomeHealthCopySourcesResponseFromJSONTyped,
    FindAllMatrixCareHomeHealthCopySourcesResponseToJSON,
    FindAllMatrixCareHomeHealthCopySourcesResponseToJSONTyped,
} from './FindAllMatrixCareHomeHealthCopySourcesResponse';

/**
 * 
 * @export
 * @interface FindAllMatrixCareHomeHealthCopySources200Response
 */
export interface FindAllMatrixCareHomeHealthCopySources200Response {
    /**
     * 
     * @type {FindAllMatrixCareHomeHealthCopySourcesResponse}
     * @memberof FindAllMatrixCareHomeHealthCopySources200Response
     */
    data?: FindAllMatrixCareHomeHealthCopySourcesResponse;
}

/**
 * Check if a given object implements the FindAllMatrixCareHomeHealthCopySources200Response interface.
 */
export function instanceOfFindAllMatrixCareHomeHealthCopySources200Response(value: object): value is FindAllMatrixCareHomeHealthCopySources200Response {
    return true;
}

export function FindAllMatrixCareHomeHealthCopySources200ResponseFromJSON(json: any): FindAllMatrixCareHomeHealthCopySources200Response {
    return FindAllMatrixCareHomeHealthCopySources200ResponseFromJSONTyped(json, false);
}

export function FindAllMatrixCareHomeHealthCopySources200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllMatrixCareHomeHealthCopySources200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllMatrixCareHomeHealthCopySourcesResponseFromJSON(json['data']),
    };
}

export function FindAllMatrixCareHomeHealthCopySources200ResponseToJSON(json: any): FindAllMatrixCareHomeHealthCopySources200Response {
    return FindAllMatrixCareHomeHealthCopySources200ResponseToJSONTyped(json, false);
}

export function FindAllMatrixCareHomeHealthCopySources200ResponseToJSONTyped(value?: FindAllMatrixCareHomeHealthCopySources200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllMatrixCareHomeHealthCopySourcesResponseToJSON(value['data']),
    };
}

